import { DirectiveOptions } from 'vue';

type ElementWithFocusHandler = HTMLElement & { _mouseHandler: () => void; _keyHandler: (e: KeyboardEvent) => void };

export const focus: DirectiveOptions = {
  bind(el: ElementWithFocusHandler) {
    el._mouseHandler = function () {
      el.style.outline = "none";
    };
    el._keyHandler = function (e: KeyboardEvent) {
      el.style.outline = "";
      if (e.code === "Tab") el.focus();
    };
    
    // Only add window event listener on client side
    if (typeof window !== 'undefined') {
      window.addEventListener("mousedown", el._mouseHandler);
    }
    el.addEventListener("keyup", el._keyHandler);
  },
  unbind(el: ElementWithFocusHandler) {
    // Only remove window event listener on client side
    if (typeof window !== 'undefined') {
      window.removeEventListener("mousedown", el._mouseHandler);
    }
    el.removeEventListener("keyup", el._keyHandler);
    el._mouseHandler = null;
    el._keyHandler = null;
  },
};